import { cn } from '../../../libs/utils/TailwindMerge';
import { ChatList } from './ChatList/ChatList';
import { ChatSettings } from './ChatSettings/ChatSettings';
import { ChatWindow } from './ChatWindow/ChatWindow';

interface ChatViewProps {
    isChatListOpen: boolean;
    isSettingsOpen: boolean;
    isDarkMode: boolean;
    chatMode: string;
    toggleDarkMode: () => void;
    changeChatMode: (mode: string) => void;
    toggleSettings: () => void;
    toggleChatList: () => void;
}

export const ChatView: React.FC<ChatViewProps> = ({
    isChatListOpen,
    isSettingsOpen,
    isDarkMode,
    chatMode,
    toggleDarkMode,
    changeChatMode,
    toggleSettings,
    toggleChatList,
}) => {
    return (
        <div className="flex flex-col lg:flex-row h-full w-full bg-slate-200 dark:bg-slate-800">
            <div
                className={cn(
                    `flex transition-all duration-200 transform`,
                    isChatListOpen ? 'w-full md:z-20 md:w-80 translate-x-0' : 'w-0 md:-z-20 -translate-x-full',
                )}>
                <ChatList toggleChatList={toggleChatList} />
            </div>
            <div className={`flex flex-grow h-[calc(100dvh-60px)] md:h-dvh ${isChatListOpen ? 'hidden md:flex' : ''}`}>
                <ChatWindow chatMode={chatMode} />
            </div>
            <div
                className={cn(
                    'fixed right-0 xl:relative h-full w-[calc(100%-60px)] z-30 transition-all duration-200 transform',
                    isSettingsOpen ? 'md:w-80 translate-x-0 opacity-100' : 'translate-x-full opacity-0',
                    !isSettingsOpen && 'w-0',
                )}>
                <ChatSettings
                    isDarkMode={isDarkMode}
                    setIsDarkMode={toggleDarkMode}
                    chatMode={chatMode}
                    changeChatMode={changeChatMode}
                    toggleSettings={toggleSettings}
                />
            </div>
        </div>
    );
};
